import { format, formatDistanceToNow } from 'date-fns';

export function formatReadableDate(input?: string): string {
	if (!input) return 'Not specified';

	const parsed = new Date(input);
	if (isNaN(parsed.getTime())) return 'Invalid date';

	const formatted = format(parsed, "EEE, MMM d 'at' h:mm a");
	const relative = formatDistanceToNow(parsed, { addSuffix: true });

	return `${formatted} (${relative})`;
}

